angular.module('impactx.item').directive('ixItemPrice', function() {
    return {
        scope: {
            item: '=',
            showNet: "=",
            showGross: "=",
            showCatalogNet: "=",
            trns: "=",
            showContentAmount: "=",
            useNumberInputDirective: "=",
            markAsChangedFunc: "&",
            hideEuel: "="
        },
        restrict: 'E',
        templateUrl: 'shared/item/templates/itemprice.html',
        controller: 'ItemPriceCtrl',
        controllerAs: 'itemPriceCtrl'
    };
});